export default __webpack_public_path__ + "static/media/iconShield.3a010a91.svg";